import type { LpEventCloneDraft } from 'src/types/lp-events';
import { benefitDay as cloneDay } from 'src/utils/benefit-dates';

export { cloneDay };

export const CLONE_FIELD_LABELS = {
  GAPropertyId: 'ID do Google Analytics',
  GAPropertySecret: 'Chave secreta do Google Analytics',
  startDate: 'Data de início',
  endDate: 'Data de término',
};

export type CloneRequiredField = keyof typeof CLONE_FIELD_LABELS;

export function clonePickerDay(value: string): Date {
  const [year, month, day] = cloneDay(value).split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function pendingCloneFields(
  values: { GAPropertyId?: string; GAPropertySecret?: string; startDate?: Date | null; endDate?: Date | null },
  source: LpEventCloneDraft['event']
): CloneRequiredField[] {
  const pending: CloneRequiredField[] = [];
  if (!values.GAPropertyId?.trim() || values.GAPropertyId.trim() === source.GAPropertyId.trim()) pending.push('GAPropertyId');
  // The source secret is never exposed. The server also checks it differs.
  if (!values.GAPropertySecret?.trim()) pending.push('GAPropertySecret');
  const start = cloneDay(values.startDate);
  const end = cloneDay(values.endDate);
  if (!start || start === cloneDay(source.startDate)) pending.push('startDate');
  if (!end || end === cloneDay(source.endDate) || end < start) pending.push('endDate');
  return pending;
}

export function clonePeriodIsValid(startDate: Date | null, endDate: Date | null): boolean {
  const start = cloneDay(startDate);
  const end = cloneDay(endDate);
  return !!start && !!end && start <= end;
}
